import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <span className="text-foreground-400 w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center"></i>
            </span>
          )}
          {item.path ? (
            <Link
              to={item.path}
              className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}